import React, {useState} from 'react';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import s from '../../PersonalOffice/CreateInvoice/CreateInvoice.module.css';
import GridTableHead from '../GridTableHead/GridTableHead';
import CreateTableRowEl from '../../PersonalOffice/CreateInvoice/components/CreateTableRowEl';
import LightGreenButton from '../Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';

import {ProductInDepotType} from '../../types/ProductSliceTypes';

type Props = {
	isLoading: boolean;
	products: ProductInDepotType[] | null;
	changeProductCallback: (
		id: string,
		action: '+' | '-' | 'manual' | 'remove',
		value?: number,
	) => void;
	isEditing?: boolean;
	hideStockColumn?: boolean;
};
const DepotProductsList: React.FC<Props> = ({
	products,
	isLoading,
	changeProductCallback,
	isEditing = false,
	hideStockColumn = false,
}) => {
	const {t} = useTranslation();
	const [visibleCount, setVisibleCount] = useState<number>(10);
	const [showAll, setShowAll] = useState<boolean>(false);

	const slicedProducts = showAll 
		? products 
		: products?.slice(0, visibleCount);

	const handleSeeMore = () => {
		if (showAll) {
			setVisibleCount(10);
			setShowAll(false);
		} else {
			const newCount = visibleCount + 20;
			if (products && newCount >= products.length) {
				setShowAll(true);
			} else {
				setVisibleCount(newCount);
			}
		}
	};
	const tableTitles = hideStockColumn 
		? [
			t('назва'),
			t('бали'),
			t('грн'),
			t('кількість'),
		]
		: [
			t('назва'),
			t('кількість на складі'),
			t('бали'),
			t('грн'),
			t('кількість'),
		];
	return (
		<>
			{isLoading ? (
				<PreLoaderComponent type={'category'} size={'big'} />
			) : slicedProducts && slicedProducts?.length > 0 ? (
				<div className={s.tableWrapper}>
					<div className={`${s.gridRow} ${s.tableHeader}`}>
						{tableTitles.map((title, index) => {
							// Для мобильных скрываем колонки балов и денег
							const shouldHideOnMobile = hideStockColumn 
								? [1, 2].includes(index) // Если скрыта колонка склада, то скрываем бали и грн
								: [1, 2, 3].includes(index); // Обычный режим: скрываем склад, бали, грн
							
							return (
								<div 
									key={title + index}
									className={`${s.cell} ${shouldHideOnMobile ? s.hideOnMobile : ''}`}
								>
									{t(title)}
								</div>
							);
						})}
					</div>
					<div className={s.tableContent}>
						{slicedProducts?.map(
							(product: ProductInDepotType) => {
								return (
									<CreateTableRowEl
										key={product.id}
										product={product}
										handleChangeProduct={changeProductCallback}
										isEditing={isEditing}
										hideStockColumn={hideStockColumn}
									/>
								);
							},
						)}
						{products && products.length > 10 && (
							<div className={s.tableButton}>
								<LightGreenButton
									type={'button'}
									text={`${t('дивитися')} ${!showAll ? t('більше') : t('менше')}`}
									onClick={handleSeeMore}
								/>
							</div>
						)}
					</div>
				</div>
			) : (
				<div className={s.noProduct}>{t('Продукти відсутні')}</div>
			)}
		</>
	);
};

export default DepotProductsList;
